/**
 * Auth redirect utilities for consistent URL handling across environments
 */

export const getAppUrl = (): string => {
  if (typeof window !== 'undefined' && window.location.origin.includes('lovableproject.com')) {
    return 'https://safurra.com';
  }
  return (typeof window !== 'undefined' ? window.location.origin : 'https://safurra.com');
};

export const getRedirectTo = (next: string = '/onboarding'): string => {
  return `${getAppUrl()}/auth/callback?next=${encodeURIComponent(next)}`;
};

// Backwards compatibility
export const getAuthRedirectUrl = getRedirectTo;

export const logAuthRedirect = (action: string, redirectUrl: string) => {
  console.log(`Auth ${action}: Redirecting to`, redirectUrl);
};